import React from 'react'
import cn from 'classnames'
import ChannelOption from './ChannelOption'

const ChannelOptions = ({ channelList, onSelect, className }) => {
  return (
    <div className={cn('grui flex', className)}>
      {channelList.map(channel => (
        <ChannelOption
          key={channel.type}
          type={channel.type}
          title={channel.title}
          icon={channel.icon}
          onSelect={onSelect}
        >
          {channel.description}
        </ChannelOption>
      ))}
    </div>
  )
}

export default ChannelOptions
